function ivhTableTreeviewConfig(ivhTreeviewOptionsProvider, ivhTreeviewInterpolateStartSymbol, ivhTreeviewInterpolateEndSymbol) {
    const symbolStart = ivhTreeviewInterpolateStartSymbol;
    const symbolEnd = ivhTreeviewInterpolateEndSymbol;

    ivhTreeviewOptionsProvider.set({
        nodeTpl: require('./customDirectives/ctxTableTreeviewNode.template.html')
    });
}

ivhTableTreeviewConfig.$inject = ['ivhTreeviewOptionsProvider', 'ivhTreeviewInterpolateStartSymbol', 'ivhTreeviewInterpolateEndSymbol'];

module.exports = ivhTableTreeviewConfig;


// WEBPACK FOOTER //
// ./src/shared/ctxTableTree/ctxTableTree.ivh.treeview.config.js